import { i18n } from 'src/i18n';
import Errors from 'src/modules/shared/error/errors';
import { getHistory } from 'src/modules/store';
import WorkflowLaunchService from 'src/modules/workflowLaunch/workflowLaunchService';
import Message from 'src/view/shared/message';
import workflowLaunchListActions from '../list/workflowLaunchListActions';

const prefix = 'WORKFLOWLAUNCH_FORM';

const workflowLaunchFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doCopy: (values) => async (dispatch) => {
    try {
      dispatch({
        type: workflowLaunchFormActions.CREATE_STARTED,
      });

      await WorkflowLaunchService.create(values);

      dispatch({
        type: workflowLaunchFormActions.CREATE_SUCCESS,
      });

      Message.success(
        i18n('entities.workflowLaunch.create.success'),
      );

      // Refresh list without redirect
      dispatch(workflowLaunchListActions.doCopyFetch());
    } catch (error) {
      Errors.handle(error);
      dispatch({
        type: workflowLaunchFormActions.CREATE_ERROR,
      });
    }
  },

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: workflowLaunchFormActions.INIT_STARTED,
      });

      let record = {};
      const isEdit = Boolean(id);

      if (isEdit) {
        record = await WorkflowLaunchService.find(id);
      }

      dispatch({
        type: workflowLaunchFormActions.INIT_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);
      dispatch({
        type: workflowLaunchFormActions.INIT_ERROR,
      });
      getHistory().push('/workflow-launch');
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: workflowLaunchFormActions.CREATE_STARTED,
      });
      await WorkflowLaunchService.create(values);
      dispatch({
        type: workflowLaunchFormActions.CREATE_SUCCESS,
      });
      Message.success(
        i18n('entities.workflowLaunch.create.success'),
      );
      getHistory().push('/workflow-launch');
    } catch (error) {
      Errors.handle(error);
      dispatch({
        type: workflowLaunchFormActions.CREATE_ERROR,
      });
    }
  },

  doUpdate: (id, values) => async (dispatch) => {
    try {
      dispatch({
        type: workflowLaunchFormActions.UPDATE_STARTED,
      });
      await WorkflowLaunchService.update(id, values);
      dispatch({
        type: workflowLaunchFormActions.UPDATE_SUCCESS,
      });
      Message.success(
        i18n('entities.workflowLaunch.update.success'),
      );
      getHistory().push('/workflow-launch');
    } catch (error) {
      Errors.handle(error);
      dispatch({
        type: workflowLaunchFormActions.UPDATE_ERROR,
      });
    }
  },
};

export default workflowLaunchFormActions;
